import TestPageActionTypes from './testPage.types';
import { getQuestionData, getThankyouModal } from './testPage.utils';
import { initialTestPageState } from '../initialState';
import { activateProctor } from '../../utils/supervisor';

export const testPageState = (state = initialTestPageState, action = {}) => {
	switch (action.type) {
		case TestPageActionTypes.SET_INITIAL_TEST_DETAILS:
			return Object.assign({}, state, { ...initialTestPageState });
		case TestPageActionTypes.TOGGLE_FEEDBACK:
			return Object.assign({}, state, {
				isFeedback: !state.isFeedback,
				submitButton: !state.isFeedback ? 'Next' : 'Submit',
				disableSubmit: state.isFeedback,
			});
		case TestPageActionTypes.SET_CURRENT_ATTEMPT_ID:
			return Object.assign({}, state, { currentAttemptId: action.payload });
		case TestPageActionTypes.START_ATTEMPT.SUCCESS:
			return Object.assign({}, state, {
				currentAttemptId: action.payload.attempt_id,
				resetCounter: 0,
				resetCounters: 0,
				attemptName: action.payload.attempt_name,
				showThankModal: false,
			});
		case TestPageActionTypes.FETCH_ATTEMPT.SUCCESS:
			return Object.assign({}, state, { ...getQuestionData(action.payload) });
		case TestPageActionTypes.SUBMIT_FEEDBACK.SUCCESS:
			return Object.assign({}, state, { submitFeedback: true });
		case TestPageActionTypes.TOGGLE_SUBMIT_ACTIVE:
			return Object.assign({}, state, { disableSubmit: action.payload });
		case TestPageActionTypes.SET_PREV_VIDEO_ID:
			return Object.assign({}, state, { prevVideoId: action.payload });
		case TestPageActionTypes.SUBMIT_ANSWER.SUCCESS:
			return Object.assign({}, state, { ...getQuestionData(action.payload) });
		case TestPageActionTypes.SHOW_THANKYOU_MODAL:
			return Object.assign({}, state, {
				thanksval: !!action.payload ? getThankyouModal(action.payload) : {},
			});
		case TestPageActionTypes.UPDATE_RESET_COUNTER:
			return Object.assign({}, state, { ...action.payload });
		case TestPageActionTypes.TOGGLE_MIC_PERMISSION:
			return Object.assign({}, state, { isMicPermitted: action.payload });
		case TestPageActionTypes.RESET_TEST_DATA:
			return Object.assign({}, state, {
				...initialTestPageState,
				isMicPermitted: state.isMicPermitted,
			});
		case TestPageActionTypes.SET_SHOW_REVIEW:
			return Object.assign({}, state, { showReview: action.payload });
		case TestPageActionTypes.SET_SHOW_THANK_YOU:
			return Object.assign({}, state, { showThankModal: action.payload });

		case TestPageActionTypes.GET_LT_TOKEN.SUCCESS:
			return Object.assign({}, state, {
				lntToken: action.payload,
			});

		case TestPageActionTypes.GET_PROCTOR_STATUS.SUCCESS:
			return Object.assign({}, state, {
				proctorResponse: action.payload,
			});
		default:
			return state;
	}
};
